.wrapper {
  box-sizing: border-box;
  clip: rect(1px, 1px, 1px, 1px);
  white-space: nowrap;
  opacity: 0;

  @media (prefers-reduced-motion: no-preference) {
    transition: opacity var(--dds-motion-surface);
  }
}

.wrapper:focus-within {
  clip: auto;
  height: auto;
  overflow: auto;
  width: 100%;
  z-index: var(--dds-zindex-skiptocontent);
  opacity: 1;
}
